import './src/vaadin-field-highlighter.js';
export * from './src/vaadin-field-highlighter.js';
